// Direct file import to avoid circular dependency through the barrel.
// The barrel exports modules (DynamicStepRenderer, useStepSubmit) that
// import entities/wizard, which would try to import useDynamicSteps
// back from the barrel before it finishes evaluating.
import { useDynamicSteps } from "../../../shared/libs/workflow-engine/use-dynamic-steps";

/**
 * Delegates to useDynamicSteps — the schema-driven step navigation hook.
 *
 * This preserves the original export name so all existing consumers
 * (pages, features, widgets) continue to work without changing imports.
 *
 * The dynamic version reads step ordering from the Sanity workflow manifest
 * (with build-time cached fallback) instead of the hardcoded wizard store.
 */
export const useServiceSteps = useDynamicSteps;
